import { render, staticRenderFns } from "./betriebsanweisungForm.vue?vue&type=template&id=4d8cb9d7&scoped=true"
import script from "./betriebsanweisungForm.vue?vue&type=script&lang=js"
export * from "./betriebsanweisungForm.vue?vue&type=script&lang=js"
import style0 from "./betriebsanweisungForm.vue?vue&type=style&index=0&id=4d8cb9d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8cb9d7",
  null
  
)

export default component.exports